<div class="page-container">
  <div class="header-section">
    <lib-breadcrumb [list]="breadcrumbs()"></lib-breadcrumb>
    <h2 class="text-lg mb-5 font-semibold text-gray-800">Document Reception</h2>
  </div>

  <div class="content-wrapper" [class.blur]="loading">

    <form [formGroup]="searchFormGrp" (ngSubmit)="searchHandler()" class="search-form-card">
      <div class="search-grid">

        <app-case-number-search [label]="userType==='lawyer'?'Case Number':'Appeal Number'"
          (caseSelected)="onCaseSearchOptionSelected($event)" formControlName="caseNumber">
        </app-case-number-search>

        <div class="form-item">
          <mat-label>Document Type</mat-label>
          <mat-form-field appearance="outline" class="full-width">
            <mat-select formControlName="documentType" (selectionChange)="onDocumentTypeChange($event.value)">
              <mat-option>
                <ngx-mat-select-search [formControl]="docTypeFilterCtrl" placeholderLabel="Search..."
                  noEntriesFoundLabel="No results found">
                </ngx-mat-select-search>
              </mat-option>
              <mat-option *ngFor="let document of filteredDocumentTypes" [value]="document">
                {{ document.docTypeId }} - {{ document.docTypeName }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="form-actions">
          <button type="reset" mat-stroked-button color="primary" (click)="resetHandler()">Reset</button>
          <button type="submit" mat-flat-button color="primary">Search</button>
        </div>

      </div>
    </form>
    <div class="section-container">
      <div class="section-header">
        <h3 class="heading">Documents</h3>

        <div class="action-toolbar">
          <button mat-button color="primary" disabled>
            <mat-icon>delete</mat-icon> Delete
          </button>
          <button mat-button color="primary" [disabled]="selectedData.length===0 || isDashboard" (click)="onPrint()">
            <mat-icon>print</mat-icon> Print
          </button>
          <button mat-button color="primary" [disabled]="selectedData.length===0 || isDashboard" (click)="sentMail()">
            <mat-icon>mail</mat-icon> Mail
          </button>
          <button mat-button color="primary" [disabled]="caseData().length === 0 || isDashboard"
            (click)="getconfirmation('Save')">
            <mat-icon>save</mat-icon> Save
          </button>
          <button mat-button color="primary" [disabled]="selectedData.length===0 || isDashboard"
            (click)="editdocument()">
            <mat-icon>edit</mat-icon> Edit
          </button>
          <button mat-button color="primary" [disabled]="isDashboard" (click)="openBacklogModal()" class="ml-2"
            *ngIf="isSupremeCourtFlg && this.caseData().length===0">

            <mat-icon svgIcon="clipboard_add"></mat-icon>
            Add Backlog
          </button>
          <button mat-button color="primary" [disabled]="isDashboard" (click)="openModal()" *ngIf="!isDirectAssign">
            <mat-icon>add</mat-icon> Add
          </button>
          <button mat-button color="primary" [disabled]="isDashboard" (click)="commentsDialog.showModal()"
            *ngIf="isDirectAssign">
            <mat-icon>assignment_turned_in</mat-icon> {{assignButtonName}}
          </button>

        </div>
      </div>

      <div class="responsive-table-wrapper">
        <cdk-virtual-scroll-viewport itemSize="48" class="virtual-viewport main-table-viewport">
          <table mat-table [dataSource]="caseDataSource" matSort class="mat-elevation-z0">

            <ng-container *ngFor="let col of columnDefinitions" [matColumnDef]="col.column">
              <ng-container *ngIf="col.column !== 'select'; else noSortHeader">
                <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColumnStyle(col.column)">
                  {{ col.labels[userType] }}
                </th>
              </ng-container>
              <ng-template #noSortHeader>
                <th mat-header-cell *matHeaderCellDef [ngStyle]="getColumnStyle(col.column)">
                  {{ col.labels[userType] }}
                </th>
              </ng-template>

              <td mat-cell *matCellDef="let element" [ngStyle]="getColumnStyle(col.column)">
                <ng-container [ngSwitch]="col.column">
                  <mat-checkbox *ngSwitchCase="'select'" [checked]="selectedData.includes(element)"
                    (change)="onCheckboxChange(element, $event.checked)">
                  </mat-checkbox>
                  <span *ngSwitchCase="'plaintiff'"> {{element.partiesByPrtIdIssuedByName}} </span>
                  <span *ngSwitchCase="'defendant'"> {{element.partyIdChargingName}} </span>
                  <span *ngSwitchCase="'caseType'"> {{element.ctpShortName}} </span>
                  <span *ngSwitchCase="'docType'"> {{element.docTypename}} </span>
                  <span *ngSwitchCase="'caseStage'"> {{element.cptShortName}} </span>
                  <span *ngSwitchCase="'caseNumber'"> {{element.courtCaseNumber}} </span>
                  <span *ngSwitchCase="'receivedDate'"> {{element.dateReceived|date}} </span>
                  <span *ngSwitchCase="'docId'"> {{element.docId}} </span>
                </ng-container>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
        </cdk-virtual-scroll-viewport>
      </div>
    </div>

    <div class="nested-tabs-section" *ngIf="caseData().length != 0">
      <div class="sub-tab-nav">
        <button class="sub-tab-btn" [class.active]="selectedTab === 'parties'"
          (click)="selectedTab = 'parties'">Parties</button>
        <button class="sub-tab-btn" [class.active]="selectedTab === 'upload'"
          (click)="selectedTab = 'upload'">Upload</button>
        <button class="sub-tab-btn" [class.active]="selectedTab === 'attachments'"
          (click)="selectedTab = 'attachments'">Attachments</button>
        <button class="sub-tab-btn" [class.active]="selectedTab === 'allDocuments'"
          (click)="selectedTab = 'allDocuments'">All Documents</button>
      </div>


      <mat-tab-nav-panel #tabPanel>
        <div class="tab-content-area" *ngIf="selectedData.length != 0">

          <div class="section-header">
            <h3 class="heading">{{getLabelValue(selectedTab)}}</h3>
            <div class="action-toolbar">
              <button *ngIf="selectedTab==='parties'||selectedTab==='attachments'" mat-button color="primary"
                (click)="partiesButtonFunction(selectedTab)"
                [disabled]="(selectedTab==='attachments'&& !selectedDoc) || isDashboard">
                <mat-icon>{{selectedTab==='parties'?'add':'delete'}}</mat-icon>
                {{selectedTab==='parties'?'Add':'Delete'}}
              </button>
            </div>
          </div>

          <div *ngIf="selectedTab === 'parties'" class="responsive-table-wrapper">
            <cdk-virtual-scroll-viewport itemSize="48" class="virtual-viewport sub-table-viewport">
              <table mat-table [dataSource]="partyDetails()" class="mat-elevation-z0">

                <ng-container matColumnDef="select">
                  <th mat-header-cell *matHeaderCellDef class="w-10"></th>
                  <td mat-cell *matCellDef="let element">
                    <mat-checkbox [checked]="selectedparties===element" [disabled]="element.termination === 'D'"
                      (change)="onPartyCheckboxChange(element, $event.checked)">
                    </mat-checkbox>
                  </td>
                </ng-container>

                <ng-container matColumnDef="partyId">
                  <th mat-header-cell *matHeaderCellDef>Party ID</th>
                  <td mat-cell *matCellDef="let element" [class.blurred-row]="element.termination === 'D'">{{
                    element.partyId }}</td>
                </ng-container>

                <ng-container matColumnDef="partyName">
                  <th mat-header-cell *matHeaderCellDef>Party Name</th>
                  <td mat-cell *matCellDef="let element" [class.blurred-row]="element.termination === 'D'">{{
                    element.partyName }}</td>
                </ng-container>

                <ng-container matColumnDef="partyRole">
                  <th mat-header-cell *matHeaderCellDef>Party Role</th>
                  <td mat-cell *matCellDef="let element" [class.blurred-row]="element.termination === 'D'">
                    <mat-form-field appearance="outline" *ngIf="element.isEdit; else roleText" class="dense-form-field">
                      <mat-select [(value)]="element.partyRoleName"
                        (selectionChange)="onPartyRoleChange(element, $event.value)">
                        <mat-option *ngFor="let role of partyRoles" [value]="role">{{ role }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <ng-template #roleText>{{ element.partyRoleName }}</ng-template>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="['select', 'partyId', 'partyName', 'partyRole']; sticky: true">
                </tr>
                <tr mat-row *matRowDef="let row; columns: ['select', 'partyId', 'partyName', 'partyRole'];"
                  [class.disabled-row]="row.termination === 'D'">
                </tr>
              </table>
            </cdk-virtual-scroll-viewport>
          </div>

          <div *ngIf="selectedTab === 'upload'" class="upload-container">
            <div class="upload-grid" *ngIf="partyDetails().length > 0">

              <div class="upload-item">
                <label>Choose File:</label>
                <div class="file-input-wrapper">
                  <input type="text" readonly [value]="selectedFile?.name || fileUrl || ''" class="custom-file-display"
                    placeholder="No file chosen">
                  <button mat-icon-button color="primary" *ngIf="!selectedFile" (click)="openFileSelector()"
                    [disabled]="isDashboard">
                    <mat-icon>folder</mat-icon>
                  </button>
                  <button mat-icon-button color="warn" *ngIf="selectedFile" (click)="clearFileUrl()">
                    <mat-icon>delete</mat-icon>
                  </button>
                  <input type="file" id="fileInput" hidden (change)="onFileSelected($event)" [disabled]="isDashboard" />
                </div>
              </div>

              <div class="upload-item">
                <label>Date Received:</label>
                <mat-form-field appearance="outline" class="full-width dense-form-field">
                  <input matInput [matDatepicker]="picker" [(ngModel)]="dateReceived" [max]="today"
                    (dateChange)="onDateChange($event)" [disabled]="isDashboard">
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
              </div>

              <div class="upload-item btn-container">
                <button mat-flat-button color="primary" (click)="onFileUpload()"
                  [disabled]="!dateReceived || !selectedFile || isUploading || isDashboard">
                  {{ isUploading ? 'Uploading...' : 'Upload' }}
                </button>
              </div>
            </div>
          </div>

          <div *ngIf="selectedTab === 'attachments'" class="responsive-table-wrapper">
            <div *ngIf="isLoadingAttachments" class="loading-overlay-inline">
              <mat-spinner diameter="30"></mat-spinner>
            </div>

            <cdk-virtual-scroll-viewport itemSize="48" class="virtual-viewport sub-table-viewport"
              *ngIf="!isLoadingAttachments">
              <table mat-table [dataSource]="attachmentsData()" class="mat-elevation-z0">

                <!-- SNo Column -->
                <ng-container matColumnDef="SNo">
                  <th mat-header-cell *matHeaderCellDef>#</th>
                  <td mat-cell *matCellDef="let attachment">
                    <mat-checkbox [checked]="selectedDoc === attachment"
                      (change)="onAttachmentsCheckboxChange(attachment, $event.checked)" [disabled]="isDashboard">
                    </mat-checkbox>
                  </td>
                </ng-container>

                <!-- Document Name Column -->
                <ng-container matColumnDef="docName">
                  <th mat-header-cell *matHeaderCellDef>Document Name</th>
                  <td mat-cell *matCellDef="let attachment">
                    <a href="javascript:void(0)" class="link-btn" (click)="downloadFile(attachment)">
                      {{ attachment.docName }}
                    </a>
                  </td>
                </ng-container>

                <!-- Upload Date Column -->
                <ng-container matColumnDef="uploadDate">
                  <th mat-header-cell *matHeaderCellDef>Upload Date</th>
                  <td mat-cell *matCellDef="let attachment">{{ attachment.timeCreated }}</td>
                </ng-container>

                <!-- Date Received Column -->
                <ng-container matColumnDef="dateReceived">
                  <th mat-header-cell *matHeaderCellDef>Date Received</th>
                  <td mat-cell *matCellDef="let attachment">{{ attachment.docUploadDateReceived }}</td>
                </ng-container>

                <!-- Close Task Action Column -->
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let attachment">
                    <button mat-button color="warn" *ngIf="attachment.showClosetask" (click)="onCloseTask(attachment)">
                      <mat-icon>close</mat-icon>
                      Close Task
                    </button>
                  </td>
                </ng-container>

                <!-- Table Header & Rows -->
                <tr mat-header-row
                  *matHeaderRowDef="['SNo', 'docName', 'uploadDate', 'dateReceived', 'actions']; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: ['SNo', 'docName', 'uploadDate', 'dateReceived', 'actions'];">
                </tr>

              </table>
            </cdk-virtual-scroll-viewport>
          </div>

          <div *ngIf="selectedTab === 'allDocuments'" class="all-docs-wrapper">
            <div class="filter-controls">
              <mat-label>{{isSupremeCourtFlg?"Select Appeal Number":"Select Case Number"}}</mat-label>
              <mat-form-field appearance="outline" class="dense-form-field">
                <mat-select [(value)]="selectedCaseNumber" (selectionChange)="onCaseNumberChange($event.value)">
                  <mat-option *ngFor="let case of getUniqueCases()" [value]="case.id">{{ case.name }}</mat-option>
                </mat-select>
              </mat-form-field>
              <button mat-stroked-button color="primary" (click)="openCommentsDialog()"
                *ngIf="commentsData().length > 0" class="p-5">
                Show Comments
              </button>
            </div>

            <div class="responsive-table-wrapper">
              <cdk-virtual-scroll-viewport itemSize="48" class="virtual-viewport sub-table-viewport">
                <table mat-table [dataSource]="listOfFiles()" class="mat-elevation-z0">
                  <ng-container matColumnDef="SNo">
                    <th mat-header-cell *matHeaderCellDef>#</th>
                    <td mat-cell *matCellDef="let files; let i = index">{{ i + 1 }}</td>
                  </ng-container>
                  <ng-container matColumnDef="docName">
                    <th mat-header-cell *matHeaderCellDef>Document Name</th>
                    <td mat-cell *matCellDef="let files">
                      <a href="javascript:void(0)" class="link-btn" (click)="downloadFile(files)">{{ files.docName
                        }}</a>
                    </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="['SNo', 'docName']; sticky: true"></tr>
                  <tr mat-row *matRowDef="let row; columns: ['SNo', 'docName'];"></tr>
                </table>
              </cdk-virtual-scroll-viewport>
            </div>
          </div>
        </div>
      </mat-tab-nav-panel>
    </div>

    <div class="nested-tabs-section"
      *ngIf="partyDetails().length!=0 && selectedTab==='parties' && selectedparties!=null">
      <div class="sub-tab-nav">
        <button class="sub-tab-btn" [class.active]="selectedTab2 === 'partiesRepresented'"
          (click)="selectedTab2 = 'partiesRepresented'">Parties Represented</button>
        <button class="sub-tab-btn" [class.active]="selectedTab2 === 'witness'"
          (click)="selectedTab2 = 'witness'">Witnesses</button>
        <button class="sub-tab-btn" [class.active]="selectedTab2 === 'groupParties'"
          (click)="selectedTab2 = 'groupParties'">Group Parties</button>
      </div>

      <div class="sub-tab-content">
        <div class="section-header">
          <h4 class="sub-heading">{{getLabelValue(selectedTab2)}}</h4>
          <div class="action-buttons">
            <button mat-button color="primary"
              *ngIf="(selectedTab2=='partiesRepresented'||selectedTab2=='witness')&&!isRepEdit"
              (click)="partiesButtonFunction(selectedTab2)" [disabled]="isDashboard">
              <mat-icon>add</mat-icon> Add
            </button>
            <button mat-button color="primary" *ngIf="selectedTab2=='partiesRepresented'"
              (click)="!isRepEdit ? modifyPartyRep() : cancelPartyRep()"
              [disabled]="selectedPartyrep===null || isDashboard">
              <mat-icon>edit</mat-icon> {{ !isRepEdit ? 'Modify' : 'Cancel' }}
            </button>
          </div>
        </div>

        <div *ngIf="selectedTab2 === 'partiesRepresented'" class="responsive-table-wrapper">
          <cdk-virtual-scroll-viewport itemSize="48" class="virtual-viewport sub-table-viewport">
            <table mat-table [dataSource]="counselPartiesData()" class="mat-elevation-z0">
              <ng-container matColumnDef="SNo">
                <th mat-header-cell *matHeaderCellDef>#</th>
                <td mat-cell *matCellDef="let element">
                  <mat-checkbox [checked]="selectedparties===element"
                    (change)="onRepPartyCheckboxChange(element, $event.checked)"></mat-checkbox>
                </td>
              </ng-container>
              <ng-container matColumnDef="parties">
                <th mat-header-cell *matHeaderCellDef>Parties</th>
                <td mat-cell *matCellDef="let r">{{r.partyFullName}}</td>
              </ng-container>
              <ng-container matColumnDef="counselId">
                <th mat-header-cell *matHeaderCellDef>
                  <span class="required-field">*</span> Counsel ID
                </th>
                <td mat-cell *matCellDef="let r">{{r.partyId}}</td>
              </ng-container>
              <ng-container matColumnDef="counselName">
                <th mat-header-cell *matHeaderCellDef>Counsel Name</th>
                <td mat-cell *matCellDef="let r">{{r.partyName}}</td>
              </ng-container>

              <ng-container matColumnDef="beginDate">
                <th mat-header-cell *matHeaderCellDef> <span class="required-field">*</span> Begin Date</th>
                <td mat-cell *matCellDef="let r">
                  <mat-form-field *ngIf="r.isEdit" appearance="outline" class="dense-form-field">
                    <input matInput [matDatepicker]="sd" [(ngModel)]="r.beginDate" [max]="today">
                    <mat-datepicker-toggle matSuffix [for]="sd"></mat-datepicker-toggle>
                    <mat-datepicker #sd></mat-datepicker>
                  </mat-form-field>
                  <span *ngIf="!r.isEdit">{{ r.beginDate | date }}</span>
                </td>
              </ng-container>

              <ng-container matColumnDef="endDate">
                <th mat-header-cell *matHeaderCellDef>
                  <span class="required-field">*</span> End Date
                </th>
                <td mat-cell *matCellDef="let r">
                  <mat-form-field *ngIf="r.isEdit || isRepEdit" appearance="outline" class="dense-form-field">
                    <input matInput [matDatepicker]="ed" [(ngModel)]="r.endDate" [max]="today">
                    <mat-datepicker-toggle matSuffix [for]="ed"></mat-datepicker-toggle>
                    <mat-datepicker #ed></mat-datepicker>
                  </mat-form-field>
                  <span *ngIf="!r.isEdit && !isRepEdit">{{ r.endDate | date }}</span>
                </td>
              </ng-container>

              <tr mat-header-row
                *matHeaderRowDef="['SNo', 'parties', 'counselId', 'counselName', 'beginDate', 'endDate']; sticky: true">
              </tr>
              <tr mat-row
                *matRowDef="let row; columns: ['SNo', 'parties', 'counselId', 'counselName', 'beginDate', 'endDate'];">
              </tr>
            </table>
          </cdk-virtual-scroll-viewport>
        </div>

        <div *ngIf="selectedTab2 === 'witness'" class="responsive-table-wrapper">
          <cdk-virtual-scroll-viewport itemSize="48" class="virtual-viewport sub-table-viewport">
            <table mat-table [dataSource]="witnessData()">
              <ng-container matColumnDef="SNo">
                <th mat-header-cell *matHeaderCellDef>#</th>
                <td mat-cell *matCellDef="let e; let i=index">{{i+1}}</td>
              </ng-container>
              <ng-container matColumnDef="witnessId">
                <th mat-header-cell *matHeaderCellDef>ID</th>
                <td mat-cell *matCellDef="let e">{{e.witnessId}}</td>
              </ng-container>
              <ng-container matColumnDef="witnessName">
                <th mat-header-cell *matHeaderCellDef>Name</th>
                <td mat-cell *matCellDef="let e">{{e.witnessName}}</td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="['SNo', 'witnessId', 'witnessName']; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: ['SNo', 'witnessId', 'witnessName'];"></tr>
            </table>
          </cdk-virtual-scroll-viewport>
        </div>

        <div *ngIf="selectedTab2 === 'groupParties'" class="responsive-table-wrapper">
          <cdk-virtual-scroll-viewport itemSize="48" class="virtual-viewport sub-table-viewport">
            <table mat-table [dataSource]="groupPartiesData()">
              <ng-container matColumnDef="SNo">
                <th mat-header-cell *matHeaderCellDef>#</th>
                <td mat-cell *matCellDef="let e; let i=index">{{i+1}}</td>
              </ng-container>
              <ng-container matColumnDef="partyid">
                <th mat-header-cell *matHeaderCellDef>ID</th>
                <td mat-cell *matCellDef="let e">{{e.partiesId}}</td>
              </ng-container>
              <ng-container matColumnDef="partiesName">
                <th mat-header-cell *matHeaderCellDef>Name</th>
                <td mat-cell *matCellDef="let e">{{e.partiesFullName}}</td>
              </ng-container>
              <ng-container matColumnDef="partyStatus">
                <th mat-header-cell *matHeaderCellDef>Status</th>
                <td mat-cell *matCellDef="let e">{{e.partyStatus}}</td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="['SNo', 'partyid', 'partiesName', 'partyStatus']; sticky: true">
              </tr>
              <tr mat-row *matRowDef="let row; columns: ['SNo', 'partyid', 'partiesName', 'partyStatus'];"></tr>
            </table>
          </cdk-virtual-scroll-viewport>
        </div>
      </div>
    </div>

  </div>

  <dialog #commentsDialog
    style="padding: 24px; border-radius: 16px; border: 1px solid #dcdcdc; width: 440px; box-shadow: 0 4px 20px rgba(0,0,0,0.15); font-family: sans-serif;">
    <h3 style="margin-top: 0; color:#006633; font-size: 18px; margin-bottom: 8px;">Comments</h3>
    <p style="color: #666; font-size: 14px; margin-bottom: 16px; line-height: 1.4;">Please provide Comments.</p>

    <!-- Curved Textarea Input Box -->
    <textarea [(ngModel)]="userComments" rows="4"
      style="width: 100%; box-sizing: border-box; padding: 12px; margin-bottom: 20px; border: 1px solid #006633; border-radius: 12px; font-family: inherit; resize: none; outline: none;"
      placeholder="Enter comments...">
  </textarea>

    <!-- Buttons Orientation Row -->
    <div style="text-align: right; gap: 12px; display: flex; justify-content: flex-end; align-items: center;">
      <!-- Cancel Button with Curved Border matching the "Reset" button style -->
      <button type="button" (click)="commentsDialog.close()"
        style="background-color: transparent; color: #333; border: 1px solid #999; padding: 8px 20px; border-radius: 20px; cursor: pointer; font-weight: 500; font-size: 14px;">
        Cancel
      </button>

      <!-- Next Button with NCMS Theme Green & Rounded Edges -->
      <button type="button" (click)="handleCommentsSubmitted(commentsDialog)"
        style="background-color: #006633; color: white; border: none; padding: 8px 24px; border-radius: 20px; cursor: pointer; font-weight: 500; font-size: 14px;">
        Save
      </button>
    </div>
  </dialog>
  <div class="spinner-overlay" *ngIf="loading">
    <mat-spinner></mat-spinner>
  </div>
</div>